<div class="end-freetrial__header">
    <eb-h2 class="m-0 mb-2">
        {{ 'try_free_trial.end' | transloco }}
    </eb-h2>
</div>
@if (ref.data.context?.featureExtraInfo) {
    <eb-alert
        [type]="'info'"
        [size]="'small'"
    >
        {{ ref.data.context?.featureExtraInfo | transloco }}
    </eb-alert>
}
<div class="end-freetrial__body">
    @if (error) {
        <eb-alert
            type="error"
            class="mb-3 w-100"
            [text]="errorMsg"
            size="small"
        />
    }
    @if (success) {
        <eb-alert
            type="success"
            class="mb-3 w-100"
            [text]="'try_free_trial.ask_sales_success' | transloco"
            size="small"
        />
    }

    <eb-label
        class="text-center"
        size="lg"
    >
        {{ 'try_free_trial.ask_sales' | transloco }}
    </eb-label>
</div>
<div class="end-freetrial__footer">
    @if (!success) {
        <eb-button-with-icon
            icon="ui/action/symbols/info"
            [disabled]="loading"
            (buttonClick)="contactMe()"
            [label]="'try_free_trial.contact_me'"
            size="small"
        >
            <eb-label
                class="d-flex align-items-center p-1"
                size="lg"
            >
                {{ 'try_free_trial.contact_me' | transloco }}
            </eb-label>
        </eb-button-with-icon>
    }
</div>
